export default {
  type: 'Typ',
  all: 'Všetky',
  analysis: 'Analýza materiálu',
  specification: 'Špecifikácia materiálu',
  analysisList: 'Analýzy materiálu',
};
